import Beside from "@modules/layout/components/beside-menu";
import PageHeader from "@modules/layout/components/page-header";
import { HeaderData } from "@data/menu";
import { useTranslations } from "next-intl";
import axios from "axios";
import https from "https";
import { GetServerSideProps, GetStaticPropsContext, InferGetServerSidePropsType, InferGetStaticPropsType } from "next";

import Image from "next/image";
import Link from "next/link";
import Head from "@/modules/common/components/head";
import Footer from "@/modules/layout/templates/footer";
import Nav from "@/modules/layout/templates/nav";
import TypeBeside from "@/modules/layout/components/type-beside-menu";
import { useRouter } from "next/router";

const imageLoader = ({ src, width }: { src: any; width: any }) => {
  return `${process.env.apiDomain}/file/${src}`;
};

const Types: InferGetServerSidePropsType<typeof getServerSideProps> = (props: any) => {
  const t = useTranslations("Menu");
  const { locale } = useRouter();
  return (
    <>
      <Head title={t(`d${props.title}`)}></Head>
      <Nav />
      <PageHeader
        title={t(`d${props.title}`)}
        image="https://d3leeb4r1qy96s.cloudfront.net/assets/img/cta-banner-image-1536x306.jpg"
      />
      <article className="page-body container page type-page status-publish hentry" id="page-body">
        <div className="row">
          <main className="page-content col-md-9 col-md-push-3">
            {/* <h2>What is New Cat Equipment?</h2>
            <p>
              Cat® equipment sets the standard for the industry, featuring over 300 models of reliable machinery
              designed to meet your needs. Our commitment to customer success is reflected in several key benefits:
            </p>
            <ul className="features">
              <li>Durability: Built to withstand tough conditions.</li>
              <li>
                Customer Support: Backed by the best distribution and product support system in the capital goods
                industry.
              </li>
              <li>Variety: Options range from construction to agriculture equipment.</li>
            </ul>
            <p>
              By choosing new Cat equipment for sale, you ensure you have the right tools for success in your projects,
              with durable and reliable equipment that can handle any challenge.
            </p>
            <p>
              Here at Thompson Machinery, we've spent over 70 years becoming a market leader in new equipment sales{" "}
              <a href="https://barloworld.mn/contact-us/locations/?fx_sid=0ce556c4-5750-4a9e-92b4-5f244dd3f273&amp;fx_uid=2ad85d88-fab2-426c-91e6-0e9e08fe3d64&amp;fx_gaId=GA1.1.1963956415.1731636069&amp;fx_s=direct&amp;fx_m=direct&amp;fx_c=direct">
                in middle<b>&nbsp;</b>and Western&nbsp;Tennessee and northern Mississippi
              </a>
              . We take the time to understand the equipment needs of our customers and always find the perfect machine
              for the job. We carry the full line-up of Cat construction equipment for sale.
            </p>
            <p>
              All of our Cat equipment is available to browse here on our site. Check out the various models and compare
              the performance, dimensions, capacities, capabilities, and features:
            </p>
            <p>
              <a className="button button--primary" style={{ borderRadius: "0px" }} href="/contact-us/">
                Contact Us For More Info
              </a>
            </p> */}
            <section className="flexible-image-cards">
              <div className="container">
                <div className="flexible-image-cards-header"></div>
                <div className="flexible-image-cards-listing">
                  <div className="row js-equal-heights">
                    {props.data && props.data.length > 0 ? (
                      props.data.map((item: any, index: any) => (
                        <div key={index} className="col-sm-4">
                          <div className="image-cards-box">
                            <Link href={props.basePath + "/" + item.id}>
                              <div className="card-image">
                                {item.img_path ? (
                                  <Image
                                    priority
                                    loader={imageLoader}
                                    src={`${process.env.apiDomain}/file/${item.img_path}`}
                                    alt={item.name}
                                    width={600}
                                    height={500}
                                    className="img-responsive entered lazyloaded"
                                  />
                                ) : (
                                  <Image
                                    priority
                                    src="/empty-image.jpg"
                                    alt="No image available"
                                    width={600}
                                    height={500}
                                    className="img-responsive entered lazyloaded"
                                  />
                                )}
                              </div>
                              <div className="image-card-content js-equal-heights-item h-[98px]">
                                <div className="image-card-btn">
                                  <span className="image-card-btn-text">{t("learnmore")}</span>
                                  <div className="image-card-btn-clippy">
                                    <span className="icon-right"></span>
                                  </div>
                                </div>
                                <h3>{locale === "en" ? item.name_en : item.name}</h3>
                              </div>
                            </Link>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="col-sm-12">
                        <p className="text-center"></p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </section>
          </main>
          <TypeBeside menu={props.data} title={t(`d${props.title}`)} translate="Menu" locale={locale} />
        </div>
      </article>
      <Footer />
    </>
  );
};

export default Types;

export const getServerSideProps: GetServerSideProps = async (context) => {
  const params = context?.params?.types;
  const instance = axios.create({
    httpsAgent: new https.Agent({
      rejectUnauthorized: false,
    }),
  });
  let config = {
    method: "get",
    rejectUnauthorized: false,
    maxBodyLength: Infinity,
    url: `${process.env.apiDomain}/store/categories?type=${params?.toString().toUpperCase()}`,
    headers: {},
  };
  const categories = await instance.request(config);

  return {
    props: {
      title: params,
      basePath: `/equipment/${params}`,
      data: categories?.data,
      messages: (await import(`../../../../messages/${context.locale}.json`)).default,
    },
  };
};
